import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveSignatureMoment,
  createSignatureMoment,
  deleteSignatureMoment,
  getAllActiveSignatureMoments,
  getAllSignatureMoments,
  getSignatureMomentByID,
  SignatureMomentImageUpload,
  updateSignatureMoment,
} from "./services/signatureMoment.service";
import {
  ISignatureMoment,
  ISignatureMomentInitialState,
} from "./signatureMomentModel";

const initialState: ISignatureMomentInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  SignatureMomentID: null,
  SignatureMomentList: [],
  SignatureMomentDetail: {
    ID: null,
    Title: "",
    Tag: "",
    SequenceNo: null,
    Image: "",
    IsActive: 1,
  },
};

const signatureMomentSlice = createSlice({
  name: "signatureMoment",
  initialState,
  reducers: {
    clearSignatureMomentDetails: (state) => {
      state.SignatureMomentDetail = initialState.SignatureMomentDetail;
    },
    setSignatureMomentID: (state, action) => {
      state.SignatureMomentID = action.payload;
    },
    clearSignatureMomentID: (state) => {
      state.SignatureMomentID = initialState.SignatureMomentID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSignatureMoments.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllSignatureMoments.fulfilled,
      (state, action: PayloadAction<ISignatureMoment[]>) => {
        state.loading = false;
        state.SignatureMomentList = action.payload || [];
      },
    );
    builder.addCase(getAllSignatureMoments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SignatureMomentList = [];
    });
    builder.addCase(createSignatureMoment.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createSignatureMoment.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createSignatureMoment.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateSignatureMoment.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateSignatureMoment.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateSignatureMoment.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteSignatureMoment.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteSignatureMoment.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSignatureMoment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getSignatureMomentByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getSignatureMomentByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.SignatureMomentDetail = action.payload;
    });
    builder.addCase(getSignatureMomentByID.rejected, (state, action) => {
      state.formLoading = false;
      state.SignatureMomentDetail = initialState.SignatureMomentDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveSignatureMoments.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveSignatureMoments.fulfilled,
      (state, action: PayloadAction<ISignatureMoment[]>) => {
        state.loading = false;
        state.SignatureMomentList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveSignatureMoments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SignatureMomentList = [];
    });

    builder.addCase(ActiveInactiveSignatureMoment.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveSignatureMoment.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveSignatureMoment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(SignatureMomentImageUpload.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(SignatureMomentImageUpload.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(SignatureMomentImageUpload.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearSignatureMomentDetails,
  clearSignatureMomentID,
  setSignatureMomentID,
} = signatureMomentSlice.actions;
export default signatureMomentSlice.reducer;
